import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule, Config } from 'ionic-angular';

import { ImageViewerDirective } from './image-viewer.directive';
import { ImageViewerComponent } from './image-viewer.component';
import { ImageViewerController } from './image-viewer.controller';

@NgModule({
	declarations: [
		ImageViewerComponent,
		ImageViewerDirective
	],
	providers: [ ImageViewerController ],
	exports: [ ImageViewerDirective ],
	entryComponents: [ ImageViewerComponent ],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class IonicImageViewerModule {}



// WEBPACK FOOTER //
// ./src/pages/zoom/module.ts